module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.error) ? _c('div', {
    staticClass: "absence-error"
  }, [_c('erreur-ecran', {
    attrs: {
      "type": _vm.typePageErreur
    }
  })], 1) : (_vm.dataReady && _vm.isExternalUser) ? _c('div', {
    staticClass: "h-100"
  }, [_c('gestion-des-absences')], 1) : (_vm.dataReady && !_vm.isExternalUser) ? _c('div', {
    staticClass: "planning-container",
    class: _vm.switchValue ? 'manager-on' : '',
    attrs: {
      "data-testid": "planningContainer-section"
    }
  }, [(_vm.estValideurConges && !_vm.isManagerNonSalarie) ? _c('el-switch', {
    attrs: {
      "active-text": "Mode manager",
      "inactive-color": "#57617A",
      "data-testid": _vm.switchValue ? 'managerMode-switch-on' : 'managerMode-switch-off'
    },
    model: {
      value: (_vm.switchValue),
      callback: function($$v) {
        _vm.switchValue = $$v
      },
      expression: "switchValue"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.switchValue || !_vm.estValideurConges) ? [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tabs-container"
  }, [_c('button', {
    staticClass: "tab-button",
    class: {
      'tab-active': _vm.activeTab === _vm.OngletAccueilSalarieEnum.Dashboard
    },
    attrs: {
      "data-testid": "planningContainer-tabDashboard-button"
    },
    on: {
      "click": function($event) {
        _vm.changeTab(_vm.OngletAccueilSalarieEnum.Dashboard)
      }
    }
  }, [_c('i', {
    class: _vm.activeTab === _vm.OngletAccueilSalarieEnum.Dashboard ? 'ri-pie-chart-2-fill' : 'ri-pie-chart-2-line'
  }), _vm._v("\n                    Tableau de bord\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "tab-button",
    class: {
      'tab-active': _vm.activeTab === _vm.OngletAccueilSalarieEnum.Planning
    },
    attrs: {
      "data-testid": "planningContainer-tabPlanning-button"
    },
    on: {
      "click": function($event) {
        _vm.changeTab(_vm.OngletAccueilSalarieEnum.Planning)
      }
    }
  }, [_c('i', {
    class: _vm.activeTab === _vm.OngletAccueilSalarieEnum.Planning ? 'ri-calendar-2-fill' : 'ri-calendar-2-line'
  }), _vm._v("\n                    Planning\n                ")])])]), _vm._v(" "), _c('dashboard-conge', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == _vm.OngletAccueilSalarieEnum.Dashboard),
      expression: "activeTab == OngletAccueilSalarieEnum.Dashboard"
    }]
  }), _vm._v(" "), _c('planning-conge', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab == _vm.OngletAccueilSalarieEnum.Planning),
      expression: "activeTab == OngletAccueilSalarieEnum.Planning"
    }],
    attrs: {
      "type": _vm.activeTab
    }
  })] : [_c('gestion-des-absences')]], 2) : _c('div', [_c('loader')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89b80910"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsencesV2/gestionDesAbsencesV2.vue.html
// module id = vA7W
// module chunks = 2